/** 画笔光标（热点在笔尖） */
export const CURSOR_PEN =
  'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'24\' height=\'24\' viewBox=\'0 0 24 24\'%3E%3Cpath fill=\'%23134e4a\' stroke=\'%23fff\' stroke-width=\'1\' d=\'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zm17.71-10.21a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z\'/%3E%3C/svg%3E") 2 22, crosshair';

/** 文字工具光标（I 形 + 标注感） */
export const CURSOR_TEXT =
  'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'24\' height=\'24\' viewBox=\'0 0 24 24\'%3E%3Cpath fill=\'%23134e4a\' stroke=\'%23fff\' stroke-width=\'0.8\' d=\'M5 4v3h5.5v12h3V7H19V4H5z\'/%3E%3C/svg%3E") 8 4, text';

/** 橡皮光标 */
export const CURSOR_ERASER =
  'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'24\' height=\'24\' viewBox=\'0 0 24 24\'%3E%3Cpath fill=\'%23b91c1c\' stroke=\'%23fff\' stroke-width=\'1\' d=\'M16.24 3.56l4.95 4.94c.78.79.78 2.05 0 2.84L12 20.53a4.008 4.008 0 0 1-5.66 0L2.81 17c-.78-.79-.78-2.05 0-2.84l10.6-10.6c.79-.78 2.05-.78 2.83 0zM4.22 15.54l3.54 3.53c.78.79 2.04.79 2.83 0L15 14.66l-6.36-6.36-4.42 7.24z\'/%3E%3C/svg%3E") 4 20, pointer';

/** 按当前工具设置地图画布鼠标样式 */
export function cursorForTool(tool) {
  switch (tool) {
    case 'sketch':
      return CURSOR_PEN;
    case 'text':
      return CURSOR_TEXT;
    case 'route':
    case 'measure':
    case 'polygon':
    case 'rectangle':
      return 'crosshair';
    case 'select':
      return 'pointer';
    case 'fill':
      return 'cell';
    case 'eraser':
      return CURSOR_ERASER;
    default:
      return '';
  }
}

export function applyMapToolCursor(map, tool) {
  if (!map?.getCanvas) return;
  try {
    map.getCanvas().style.cursor = cursorForTool(tool) || '';
  } catch (_) { /* ignore */ }
}
